import apiFetch from '../apiFetch'

export default function (idEntradaAlmacenProducto , token) {
  return apiFetch({endPoint: `EntradaAlmacen/comprobarEliminacionEntradaAlmacenProducto?idEntradaAlmacenProducto=` + idEntradaAlmacenProducto , method: 'GET', body: null, token: token})
}